import _ from 'root/libs/exaforte/react/lodash';
import Model from './Model';
import Config from 'root/globals/Config';

export default class ReactController
{
    constructor(component, config)
    {
        this.id                             = Math.floor((1 + Math.random()) * 0x10000);
        this.config                         = {...{data_url: null, save_url: Config.SERVER_REQUEST_URL + '?ajax_id=37&form-action=edit', save_settings: null, filter: null, remove_models_after_save: false, cache: (process.env.NODE_ENV != 'development'), format_data: (response) => { return response;}, node: {server: null, components: [], receive_callback: null}}, ...config};
        this.component                      = component;
        this.child_components               = {};
        this.cache                          = {};
        this.saving                         = false;
        this.ignore_warnings                = false;
        this.models                         = {};
        this.initialized                    = false;
        this.abort_controller               = null;
        this.node_message_queue             = [];
        this.apply_models_to_state_queue    = [];
        this.node_callback                  = this.node_callback.bind(this);

        if(this.config.node.server && this.config.node.components.length > 0)
        {
            this.config.node.server.on('server receive updates from components ' + this.id, this.node_callback);
            
            this.bind_node_server_updates();
            
            // De connectie is weer terug, dus de binding kan weer worden gemaakt
            this.config.node.server.on('server client initialized', this.bind_node_server_updates.bind(this));
        }
        
        var currentMethod = (component.componentWillUnmount ? component.componentWillUnmount.bind(component) : null);

        component.componentWillUnmount = () => {
            this.release();
            
            if(typeof currentMethod != 'undefined' && currentMethod != null)
                currentMethod();
        }

        if(this.config.cache)
        {
            if(!component.originalShouldComponentUpdate)
                component.originalShouldComponentUpdate = (component.shouldComponentUpdate ? component.shouldComponentUpdate.bind(component) : null);
    
            component.shouldComponentUpdate = (nextProps, nextState) => {
                if(!_.is_empty(this.cache))
                    for(let id in this.cache)
                        for(let i in this.cache[id].components)
                        {
                            // Als ook maar 1 component is aangepast moeten we de cache legen.
                            if(!_.isEqual(nextState.models[this.cache[id].components[i]], component.state.models[this.cache[id].components[i]]))
                            {
                                delete this.cache[id];
                                break;
                            }
                        }
    
                if(component.originalShouldComponentUpdate)
                    return component.originalShouldComponentUpdate(nextProps, nextState);
                    
                return true;
            }
        }
    }
    
    node_callback(response) {
        if(this.is_saving() || !_.is_empty(this.node_message_queue))
            this.node_message_queue.push(response);
        else
            this.handle_node_callback(response);
    }
    
    handle_node_callback(response) {
        let extraData           = {};
        let original_response   = response;
        
        if(this.component.state)
            extraData.fetching = this.component.state.fetching;

        if(this.config.node.before_receive_callback)
        {
            // In de before_receive_callback kunnen we de response manipuleren voor de apply_models_to_state. Bijvoorbeeld om referenties te fixen. Maar die hoeven niet mee te komen naar de receive_callback. Want we fixen alleen de referenties en hebben geen save gedaan op de gefixte items.
            original_response   = _.cloneDeep(original_response);
            extraData           = {...this.config.node.before_receive_callback(response, this), ...extraData};
        }

        this.apply_models_to_state(this.config.format_data(response), extraData, (this.config.node.receive_callback ? {callback: () => {
            this.config.node.receive_callback(original_response, this);
        }} : null));
    }
    
    handle_node_message_queue() {
        if(!_.is_empty(this.node_message_queue))
        {
            for(let i in this.node_message_queue)
                this.handle_node_callback(this.node_message_queue[i]);
        
            this.node_message_queue = [];
        }
    }
    
    bind_node_server_updates() {
        this.config.node.server.emit('server listen to updates from components', {id: this.id, components: this.config.node.components});
    }
    
    create_models(models, settings) {
        let amount  = 0;
        settings    = {...{update_if_exists: false, skip_new_records: false, return_models: false, return_models_split_components: true, component_classes: {}, direct_data: true, update_state_data: false, components: [], keep_keys: true, limit: false}, ...settings};

        for(let component in models)
            for(let bind_id in models[component])
            {
                amount++;
                let data = _.cloneDeep(models[component][bind_id]);

                if(!settings.direct_data)
                    data = data.data;

                if(this.models[component] && this.models[component][bind_id])
                {
                    if(settings.update_if_exists && data)
                        for(let fieldname in data)
                            this.models[component][bind_id].set_field_data({field: fieldname, value: data[fieldname], trigger_after_field_change: false});
                }
                else
                {
                    if(settings.skip_new_records)
                        continue;

                    let model;

                    if(_.isPlainObject(settings.component_classes) && settings.component_classes[component])
                        model = new settings.component_classes[component]({...{data: data}, ...{controller: this, name: component}});
                    else if(!_.isPlainObject(settings.component_classes))
                        model = new settings.component_classes({...{data: data}, ...{controller: this, name: component}});
                    else
                        model = new Model({...{data: data}, ...{controller: this, name: component}});
                    
                    if(!_.is_empty(settings.components))
                        for(let i in settings.components)
                            model.addComponent(settings.components[i]);

                    if(settings.update_state_data && data)
                    {
                        if(this.component.state.models[model.name] && this.component.state.models[model.name][model.get_bind_id()])
                            model.reset_data_to_state();
                        
                        for(let fieldname in data)
                            this.models[component][bind_id].set_field_data({field: fieldname, value: data[fieldname], trigger_after_field_change: false});
                    }
                }
            }

        if(settings.return_models)
        {
            let models_collection = {};
            
            if(!settings.keep_keys)
                models_collection = [];
            
            for(let component in models)
            {
                if(settings.skip_new_records && !this.models[component])
                    continue;
                
                if(settings.return_models_split_components)
                    models_collection[component] = {};

                for(let bind_id in models[component])
                {
                    if(settings.skip_new_records && !this.models[component][bind_id])
                        continue;
                    
                    if(settings.return_models_split_components)
                        models_collection[component][bind_id] = this.models[component][bind_id];
                    else if(settings.keep_keys)
                        models_collection[bind_id] = this.models[component][bind_id];
                    else
                        models_collection.push(this.models[component][bind_id]);
                }
            }

            if(settings.limit == 1)
            {
                if(settings.return_models_split_components)
                    models_collection = _.values(models_collection)[0];
                
                models_collection = _.values(models_collection)[0];
            }

            return models_collection;
        }
    }
    
    get_models_from_data(settings)
    {
        settings.data = {...{format: 'asStateObject', merge: settings.merge_data_and_models}, ...settings.data};
        
        if(settings.data.limit == 1)
            settings.data.format = '';
        
        let data = (settings.merge_data_and_models ? this.get_data_and_models(settings.data) : this.get_data(settings.data));
        
        if(settings.data.limit == 1 && !_.is_empty(data))
            data = this._asStateObject([data]);
        
        settings.models = {...{return_models: true, return_models_split_components: (_.size(settings.data.models) != 1)}, ...settings.models};

        return this.create_models(data, settings.models);
    }
    
    fetch_data(settings)
    {
        if(!settings || !settings.retries || settings.retries == 0)
            settings = {...{data_url: this.config.data_url, method: 'POST', xhrFields: { withCredentials: true }, retries: 0, headers: {'X-React-App': 1}, debug: false, credentials: 'include', extraData: {}, reset_current_state: false, set_fetching_state: true}, ...(settings || {})};
        
        if(settings.data_url)
        {
            if(!settings || !settings.retries || settings.retries == 0)
            {
                if(settings.set_fetching_state && (!this.component.state || this.component.state.fetching !== true))
                    this.component.setState({fetching: true})

                // Als er een filter aanwezig is moeten we de waardes meesturen in de body
                if(this.config.filter && this.initialized)
                    _.set_object_chain(settings, {chain: ['body', 'filter'], value: this.config.filter.get_filter()});

                if(settings.body)
                    settings.body = _.json_to_form_data(settings.body);

                if(this.abort_controller !== null)
                    this.abort_controller.abort()
                
                this.abort_controller   = new AbortController();
                let signal              = this.abort_controller.signal;
                settings                = {...settings, signal};
            }

            return fetch(settings.data_url, settings)
            .then((response) => response.text())
            .then((response) => {
                if(settings.debug)
                    console.log(response);

                response                = JSON.parse(response);
                this.initialized        = true
                this.abort_controller   = null;
                
                this.fetch_data_callback(response, settings);

                return response;
            }).catch(err => {
                if((err.message === 'Timeout' || err.message === 'Network request failed') && settings.retries < 5)
                    return this.fetch_data({...settings, retries: (settings.retries + 1)});

                if(err.name === 'AbortError')
                    return Promise.resolve({status: false});
                else
                    this.abort_controller = null;
                
                return Promise.reject(err);
            });
        }
        
        return Promise.reject({status: false, error: 'no data url'});
    }
    
    fetch_data_callback(response, settings) {
        if(response.status)
        {
            let extra_data = {};
            
            // reset_current_state check omdat het kan zijn dat je nieuwe data toevoegt aan de state en dan niet weer de fielddefines erbij zet.
            if(settings.reset_current_state || !_.is_empty(response.fielddefines))
                extra_data = {fielddefines: response.fielddefines || {}, ...extra_data};
            
            extra_data = {...extra_data, ...(response.extraData || {}), ...settings.extraData};

            // Filter velden instellen, maar nog niet de default waardes neerzetten. Dit doen we nadat alles is ingeladen.
            if(this.config.filter)
                this.config.filter.set_fields(response.filter || {}, {set_default_value_for_mandatory_fields: false});

            this.apply_models_to_state(this.config.format_data(response.models), extra_data, {reset_current_state: settings.reset_current_state, callback: () => {
                // Standaard waardes inladen in het filter
                if(this.config.filter)
                    this.config.filter.set_default_value_for_mandatory_fields();
            }});
        }
        else
            this.component.setState({fetching: false})
    }
    
    setSavingState(saving)
    {
        this.saving = saving;
        
        this.component.setState({saving: this.saving});
        
        if(_.size(this.child_components) > 0)
            for(let i in this.child_components)
                this.child_components[i].setState({saving: this.saving});
    }
    
    addChildComponent(component)
    {
        this.child_components[component.constructor.name] = component;
        
        var currentMethod = (component.componentWillUnmount ? component.componentWillUnmount.bind(component) : null);
        
        component.componentWillUnmount = () => {
            if(this.child_components[component.constructor.name])
                delete this.child_components[component.constructor.name];
            
            if(currentMethod)
                currentMethod();
        }
    }
    
    get_data(settings)
    {
        settings = {...{sort_by: 'asc', type: 'state', offset: 0, models: {}, format: '', models_object: 'object', cache: {}, cloneDeep: true}, ...settings}
        
        if(this.config.cache && settings.cache && this.cache[settings.cache.id])
            return _.cloneDeep(this.cache[settings.cache.id].data);
        
        let response    = (settings.models_object == 'object' ? {} : []);
        let models_size = _.size(settings.models);

        if(models_size == 0 || !this.component.state || _.size(this.component.state.models) == 0)
        {
            response = [];

            if(settings.format)
            {
                if(_.isString(settings.format))
                    response = this['_' + settings.format](response, settings)
                else if(_.isFunction(settings.format))
                    response = settings.format(response, settings)
            }

            return response;
        }
        
        for(let model_id in this.component.state.models)
        {
            if(!_.includes(_.format_input(settings.models), _.format_input(model_id)))
                continue

            if(settings.models_object == 'object')
                response = {...response, ...this.component.state.models[model_id]};
            else
                response = [...response, ..._.values(this.component.state.models[model_id])];
        }

        if(_.size(response) == 0)
            return this.format_data([], settings);

        let size = _.size(settings.filter_field);

        if(size > 0)
        {
            if(size == 1 && settings.filter_field.id && settings.models_object == 'object' && !settings.filter_field.id.type && !settings.format)
            {
                // het id moet natuurlijk wel bestaan
                if(response[settings.filter_field.id.value])
                    response = {[settings.filter_field.id.value]: response[settings.filter_field.id.value]};
                else
                    response = [];
            }
            else
                response = _.filter(response, _.handle_filter_fields.bind(settings));
            
            if(_.size(response) == 0)
                return this.format_data([], settings);
        }
        else
            response = _.values(response);

        let formatted_data = this.format_data((settings.cloneDeep ? _.cloneData(response) : response), settings);
        
        if(this.config.cache && !_.is_empty(settings.cache))
            this.cache[settings.cache.id] = {components: [...settings.models, ...(settings.cache.format_components || [])], data: formatted_data};

        return formatted_data;
    }
    
    get_sorting(settings) {
        let sort_functions  = [];
        let sort_by         = [];
        
        for(let i in settings)
        {
            if(settings[i].function)
                sort_functions.push(settings[i].function);
            else
            {
                if(settings[i].values)
                    settings[i].values = _.format_input(settings[i].values, {string_to_lower: true});
                
                sort_functions.push((item) => { 
                    let value = _.format_input((item instanceof Model ? item.get_field_data(settings[i].field) : item[settings[i].field]), {string_to_lower: true});
                    
                    if(settings[i].values)
                    {
                        let index = settings[i].values.findIndex(item => item == value);
                        
                        if(index != -1)
                            value = index;
                        else
                            value = settings[i].values.length;
                    }
                    
                    return value;
                });
            }
            
            sort_by.push((!settings[i].by ? 'asc' : settings[i].by));
        }
        
        return {functions: sort_functions, by: sort_by};
    }
    
    get_models(settings)
    {
        settings        = {...{sort_by: 'asc', models_object: 'object', type: 'models', offset: 0, models: {}, format: ''}, ...settings}
        let response    = (settings.models_object == 'object' ? {} : []);

        if(_.size(settings.models) == 0 || _.size(this.models) == 0)
        {
            response = [];

            if(settings.format)
            {
                if(_.isString(settings.format))
                    response = this['_' + settings.format](response, settings)
                else if(_.isFunction(settings.format))
                    response = settings.format(response, settings)
            }

            return response;
        }

        for(let model_id in this.models)
        {
            if(!_.includes(_.format_input(settings.models), _.format_input(model_id)))
                continue

            if(settings.models_object == 'object')
                response = {...response, ...this.models[model_id]}
            else
                response = [...response, ..._.values(this.models[model_id])];
        }
        
        if(_.size(response) == 0)
        {
            response = [];
            
            if(settings.format)
            {
                if(_.isString(settings.format))
                    response = this['_' + settings.format](response, settings)
                else if(_.isFunction(settings.format))
                    response = settings.format(response, settings)
            }

            return response;
        }

        if(_.size(settings.filter_field) > 0)
        {
            response = _.filter(response, _.handle_filter_fields.bind(settings));
            
            if(_.size(response) == 0)
            {
                response = [];

                return response;
            }
        }
        else
            response = _.values(response);
        
        if(settings.key && _.is_empty(settings.format))
            settings.format = 'asGrouped';
        
        return this.format_data(response, settings);
    }
    
    // Models ook toevoegen. Wanneer je in een loop plant kan de state nog niet zijn geupdate omdat er een vertraging in zit.
    get_data_and_models(settings)
    {
        let after_combine_settings  = _.cloneDeep({...{sort_by: 'asc', type: 'state', offset: 0, models: {}, format: ''}, ...settings});
        settings                    = {...{sort_by: 'asc', type: 'state', offset: 0, models: {}, format: '', merge: false}, ...settings, ...{sort: null, limit: null, format: 'asGrouped', key: (settings.models_object == 'array' ? {component_id: 'id'} : 'id'), after_format_sort: null, after_format_limit: null}};
        let data                    = this.get_data(settings);
        settings.type               = 'models';
        settings.key                = 'id';
        let models                  = this.get_models(settings);
        
        // als je voor array kiest betekend dit altijd dat je meerdere components tegelijk hebt waardoor je id hebt die elkaar kunnen overschrijven. 
        // In dit geval komt er vanuit de get_data een key component_id => id, ipv alleen id.
        if(settings.models_object == 'array')
        {
            if(!_.is_empty(models))
                for(let bind_id in models)
                {
                    if(!data[models[bind_id].config.name] || !data[models[bind_id].config.name][bind_id])
                    {
                        if(!data[models[bind_id].config.name])
                            data[models[bind_id].config.name] = {};
                        
                        data[models[bind_id].config.name][bind_id] = {component_id: models[bind_id].config.name, ...models[bind_id].data}; // component_id omdat hij ander vanuit get_data_and_models op zijn bek gaat in de _asStateObject functie.
                    }
                    else if(settings.merge)
                        data[models[bind_id].config.name][bind_id] = {...data[models[bind_id].config.name][bind_id], ...models[bind_id].data};
                }
            
            // De component_id weghalen uit het object en de records samenvoegen zodat ze daarna verder in het filter of dergelijke opgepakt kunnen worden
            data = _.reduce(data, (current, rows) => current.concat(_.values(rows)), []);
        }
        else
        {
            if(!_.is_empty(models))
                for(let bind_id in models)
                {
                    if(!data[bind_id])
                        data[bind_id] = {component_id: models[bind_id].config.name, ..._.cloneData(models[bind_id].data)}; // component_id omdat hij ander vanuit get_data_and_models op zijn bek gaat in de _asStateObject functie.
                    else if(settings.merge)
                        data[bind_id] = {...data[bind_id], ..._.cloneData(models[bind_id].data)};
                }
        }

        if(after_combine_settings.after_combine_filter_field)
            data = _.filter(data, _.handle_filter_fields.bind({filter_field: after_combine_settings.after_combine_filter_field}));

        return this.format_data(data, after_combine_settings);
    }
    
    format_data(data, settings)
    {
        if(!_.is_empty(data))
        {
            if(settings.sort)
            {
                let sort    = this.get_sorting(settings.sort);
                data        = _.orderBy(data, sort.functions, sort.by);
            }
            
            if((settings.limit && settings.limit > 0) || (settings.offset && settings.offset > 0))
            {
                data = _.slice(_.values(data), settings.offset, settings.offset + (settings.limit ? settings.limit : _.keys(response).length));
                
                if(settings.limit == 1)
                    data = data[0];
            }
        }
        
        if(settings.format)
        {
            if(_.isString(settings.format))
                data = this['_' + settings.format](data, settings)
            else if(_.isFunction(settings.format))
                data = settings.format(data, settings)
            
            if(!_.is_empty(data))
            {
                if(settings.after_format_filter)
                {
                    // Als het een array is gebruiken we filter, anders pickBy om de keys vanuit de format te behouden.
                    if(Array.isArray(data))
                        data = _.filter(data, _.handle_filter_fields.bind({filter_field: settings.after_format_filter}));
                    else
                        data = _.pickBy(data, _.handle_filter_fields.bind({filter_field: settings.after_format_filter}));
                }
                
                if(settings.after_format_sort)
                {
                    let sort    = this.get_sorting(settings.after_format_sort);
                    data        = _.orderBy(data, sort.functions, sort.by);
                }
                
                if((settings.after_format_limit && settings.after_format_limit > 0) || (settings.after_format_offset && settings.after_format_offset > 0))
                {
                    settings.after_format_offset    = settings.after_format_offset || 0;
                    data                            = _.slice(_.values(data), settings.after_format_offset, settings.after_format_offset + (settings.after_format_limit ? settings.after_format_limit : _.keys(data).length));
                    
                    if(settings.after_format_limit == 1)
                        data = data[0];
                }
            }
        }
        
        return data;
    }
    
    _asSectionList(response)
    {
        let formattedResponse = {}
        
        for(var i in response)
        {
            let title = response[i].firstname.substring(0,1).toUpperCase();
            
            if(!formattedResponse[title])
                formattedResponse[title] = {title: title, data: []}
            
            formattedResponse[title].data.push(response[i])
        }

        return _.values(formattedResponse)
    }
    
    _asFlatList(response)
    {
        return _.values(response)
    }
    
    _asSelectList(response)
    {
        return _.map(response, (data) => {return {value: data.id, label: data.title, ...(data.archived ? {archived: data.archived} : {})}});
    }
    
    _asGrouped(response, settings)
    {
        let data        = {};
        let keychain    = [];

        if(!_.isArray(settings.key) && !_.isObject(settings.key))
            settings.key = [settings.key];
        
        settings.key = this._format_keys(settings.key);

        this._generate_keychain(settings.key, [], keychain, settings);
        this._format_data_recursive(keychain, response, data, settings);

        return data;
    }
    
    _asData(response, settings)
    {
        let formattedResponse = [];

        for(let i in response)
            formattedResponse.push(response[i].get_data());

        return formattedResponse;
    }
    
    _asStateObject(response, settings)
    {
        let formattedResponse = {}

        for(let i in response)
        {
            if(!formattedResponse[response[i].component_id])
                formattedResponse[response[i].component_id] = {};

            formattedResponse[response[i].component_id][(_.is_empty(response[i].bind_id) ? response[i].id : response[i].bind_id)] = response[i];
        }

        return formattedResponse;
    }
    
    _format_keys(keys) {
        let temp    = _.cloneDeep(keys);
        keys        = {};
        
        for(let i in temp)
        {
            if(_.isObject(temp[i]) && !_.isArray(temp[i]))
            {
                let key = _.keys(temp[i])[0];

                if(typeof _.format_input(i) == 'string')
                {
                    keys[i]         = {};
                    keys[i][key]    = temp[i][key];
                }
                else
                    keys[key] = temp[i][key];

                if(_.isObject(keys[key]))
                    keys[key] = this._format_keys(keys[key]);
            }
            else
                keys[i] = temp[i];
        }

        return keys;
    }
    
    _generate_keychain(structures, keychain, keychain_collection, settings)
    {
        for(let key in structures)
        {
            let value               = structures[key];
            let structure_keychain  = _.cloneDeep(keychain);

            if(_.isObject(value))
            {
			    structure_keychain.push({name: key, siblings: _.size(structures)});
                this._generate_keychain(value, structure_keychain, keychain_collection, settings);
            }
            else
            {
                if(typeof _.format_input(key) == 'string')
                {
                    structure_keychain.push({name: key, siblings: _.size(structures)});
                    structure_keychain.push({name: value, siblings: 1});
                }
                else
				    structure_keychain.push({name: value, siblings: _.size(structures)});

				keychain_collection.push(structure_keychain);
            }
        }
    }
    
    _format_data_recursive(keychains, data, response, settings)
    {
        let value_count = _.size(data);
        let index       = 0;

        for(let i in data)
        {
            let row         = data[i];
            let last_value  = (index == (value_count - 1));
			let row_data 	= row;

            for(let x in keychains)
            {
                let keychain        = keychains[x];
                let value_response  = response;
                let last_index      = _.size(keychain);
				let last_record 	= keychain[last_index - 1];

				if(!last_record.output || _.is_empty(last_record.output))
				{
					last_record.output = 'normal';
					
					if(last_record.name == '$auto_increment$')
						last_record.output = 'auto_increment';
					else if(last_record.name == '$keys$')
					{
					    keychain.pop();
					    
					    last_index          = _.size(keychain);
				        last_record         = keychain[last_index - 1];
				        last_record.output  = 'keys';
					}
					else if(settings.overwrite_keys === false || settings.overwrite_keys != last_record.name || (_.isArray(settings.overwrite_keys) && !in_array(last_record.name, settings.overwrite_keys)))
						last_record.output = 'not_overwrite_keys';
				}
				
				let output = last_record.output;

				for(let y in keychain)
				{
				    let keychain_item = keychain[y];

					if(keychain_item.siblings > 1)
					{
					    if(!value_response[keychain_item.name])
					    {
					        if(keychain_item.name == '$auto_increment$')
					            value_response[keychain_item.name] = [];
                            else
					            value_response[keychain_item.name] = {};
					    }

						value_response = value_response[keychain_item.name];
					}

					// laatste record overslaan
					if(!_.is_empty(keychain_item['output']))
						continue;

                    let key = (row instanceof Model ? row.get_field_data(keychain_item.name) : row[keychain_item.name]);

					if(!value_response[key])
					{
					    if(y == (last_index - 2) && output == 'auto_increment')
					        value_response[key] = [];
					    else
						    value_response[key] = {};
					}
						
					value_response = value_response[key];
				}
				
				if(output == 'auto_increment')
					value_response.push(row_data);
				else if(output == 'keys')
				{
				    let value = (row instanceof Model ? row.get_field_data(last_record.name) : row[last_record.name]);

				    if(!_.is_empty(value))
				        value_response[value] = value;
				}
				else if(output == 'not_overwrite_keys')
				{
					if(!value_response[(row instanceof Model ? row.get_field_data(last_record.name) : row[last_record.name])])
						value_response[(row instanceof Model ? row.get_field_data(last_record.name) : row[last_record.name])] = (settings.withRowCount ? {...{count:0}, ...row_data} : row_data);
					
					if(settings.withRowCount)
					    value_response[(row instanceof Model ? row.get_field_data(last_record.name) : row[last_record.name])].count++;
				}
            }
            
            index++;
        }
    }
    
    apply_models_to_state(models, extraData, settings)
    {
        this.apply_models_to_state_queue.push({ models, extraData, settings });

        if(!this.is_batching_apply_models_to_state)
        {
            this.is_batching_apply_models_to_state = true;

            // Plaats de batchverwerking in de volgende microtask, dit om het gedrag van batching te simuleren
            Promise.resolve().then(() => {
                this.handle_apply_models_to_state();
            });
        }
    }
    
    handle_apply_models_to_state() {
        this.component.setState((currentState) => {
            
            if(!currentState.models)
                currentState.models = {};

            let newData = _.cloneData(currentState.models);

            for(let i in this.apply_models_to_state_queue)
            {
                let settings = {...{delete_on_removed: true, reset_current_state: false}, ...this.apply_models_to_state_queue[i].settings};
                
                if(settings.reset_current_state)
                    newData = {};

                for(var component_id in this.apply_models_to_state_queue[i].models)
                {
                    if(!newData[component_id])
                        newData[component_id] = {};
                    
                    for(var bind_id in this.apply_models_to_state_queue[i].models[component_id])
                    {
                        if(this.apply_models_to_state_queue[i].models[component_id][bind_id].removed == 't' && settings.delete_on_removed)
                        {
                            if(newData[component_id][bind_id])
                                delete newData[component_id][bind_id];
                            
                            continue
                        }
                        
                        let new_bind_id = bind_id;
    
                        if(new_bind_id.toString().startsWith('new-'))
                        {
                            if(this.apply_models_to_state_queue[i].models[component_id][bind_id].bind_id)
                                new_bind_id = this.apply_models_to_state_queue[i].models[component_id][bind_id].bind_id;
                            else if(this.apply_models_to_state_queue[i].models[component_id][bind_id].id)
                                new_bind_id = this.apply_models_to_state_queue[i].models[component_id][bind_id].id;
        
                            if(newData[component_id][bind_id] && bind_id != new_bind_id)
                                delete newData[component_id][bind_id];
                        }
                        
                        newData[component_id][new_bind_id] = {...{component_id: component_id}, ...(newData[component_id][new_bind_id] || {}), ...this.apply_models_to_state_queue[i].models[component_id][bind_id]};
                    }
                }
            }
            
            for(let component_id in newData)
                if(_.is_empty(newData[component_id]))
                    delete newData[component_id];

            let extraData = {};
            
            for(let i in this.apply_models_to_state_queue)
            {
                if(!this.apply_models_to_state_queue[i].extraData)
                    continue;
                
                if(this.apply_models_to_state_queue[i].extraData.fielddefines)
                    this.apply_models_to_state_queue[i].extraData.fielddefines = {...(currentState.fielddefines || {}), ...(extraData.fielddefines || {}), ...this.apply_models_to_state_queue[i].extraData.fielddefines};
                
                extraData = {...extraData, ...this.apply_models_to_state_queue[i].extraData};
            }

            return {fetching: false, ...extraData, ...{models: newData}};
        }, () => {
            // Reset de vlag voor batchverwerking en de queue.
            let old_queue                           = this.apply_models_to_state_queue;
            this.apply_models_to_state_queue        = [];
            this.is_batching_apply_models_to_state  = false;

            for(let i in old_queue)
                if(old_queue[i].settings && old_queue[i].settings.callback)
                    old_queue[i].settings.callback();

            this.handle_node_message_queue();
            this.update();
        });
    }
    
    update()
    {
        this.direct_update();
    }
    
    direct_update() {
        if(_.size(this.child_components) > 0)
            for(var i in this.child_components)
                this.child_components[i].forceUpdate();
    }
    
    has_changes()
    {
        for(let type in this.models)
        {
            if(_.size(this.models[type]) > 0 && _.isPlainObject(this.models[type]))
                for(let id in this.models[type])
                {
                    if(this.models[type][id].has_changes())
                        return true
                }
        }
        
        return false;
    }
    
    check_values(settings)
    {
        settings        = {...{update: true, models: this.models}, ...settings};
        let has_errors  = this.has_errors();

        for(let type in settings.models)
        {
            if(_.size(settings.models[type]) > 0 && _.isPlainObject(settings.models[type]))
                for(let id in settings.models[type])
                {
                    if(!settings.models[type][id].has_data() && !settings.models[type][id].has_changes())
                    {
                        // Als hij voorheen wel errors had kunnen die leeggemaakt worden. Want dit model zal niet meer meekomen in de commit omdat hij init_empty is.
                        if(settings.models[type][id].has_errors())
                            settings.models[type][id].errors = {};

                        continue;
                    }

                    settings.models[type][id].check_values({...settings, ...{update: false}});
                }
        }

        // has_errors is om te kijken of er eerst wel errors waren die er nu niet meer zijn. Dan kunnen we ook de update triggeren.
        if(settings.update && (has_errors || this.has_errors()))
        {
            this.component.forceUpdate();
		    this.update();
        }
    }
    
    has_errors(settings)
    {
        settings = { models: this.models, ...settings };
        
        for(let type in settings.models)
        {
            if(_.size(settings.models[type]) > 0 && _.isPlainObject(settings.models[type]))
                for(let id in settings.models[type])
                {
                    if(_.size(settings.models[type][id].errors) > 0)
                        return true
                }
        }
        
        return false;
    }
    
    get_errors(settings)
    {
        settings    = {return_type: 'object', ...settings};
        let errors  = (settings.return_type == 'array' ? [] : {});
        
        for(let type in this.models)
            if(_.size(this.models[type]) > 0 && _.isPlainObject(this.models[type]))
                for(let id in this.models[type])
                {
                    if(!this.models[type][id].has_errors())
                        continue;
                    
                    if(settings.return_type == 'array')
                        for(let i in this.models[type][id].errors)
                            errors.push(this.models[type][id].errors[i]);
                    else
                        _.set_object_chain(errors, {chain: [type, id], value: this.models[type][id].errors});
                }
        
        return errors;
    }
    
    has_warnings(settings)
    {
        if(this.ignore_warnings)
            return false;
        
        settings = { models: this.models, ...settings };

        for(let type in settings.models)
        {
            if(_.size(settings.models[type]) > 0 && _.isPlainObject(settings.models[type]))
                for(let id in settings.models[type])
                {
                    if(settings.models[type][id].has_warnings())
                        return true
                }
        }
        
        return false;
    }
    
    get_warnings(settings)
    {
        settings        = {return_type: 'object', ...settings};
        let warnings    = (settings.return_type == 'array' ? [] : {});
        
        for(let type in this.models)
            if(_.size(this.models[type]) > 0 && _.isPlainObject(this.models[type]))
                for(let id in this.models[type])
                {
                    if(!this.models[type][id].has_warnings())
                        continue;
                    
                    if(settings.return_type == 'array')
                        for(let i in this.models[type][id].warnings)
                            warnings.push(this.models[type][id].warnings[i]);
                    else
                        _.set_object_chain(warnings, {chain: [type, id], value: this.models[type][id].warnings});
                }
        
        return warnings;
    }
    
    get_changed_data(settings)
    {
        let data    = {};
        settings    = {...{models: this.models, split_init_from_changed_data: false, data_as_string: false}, ...settings};
        
        for(let type in settings.models)
        {
            if(_.isPlainObject(settings.models[type]))
                for(let id in settings.models[type])
                {
                    if(!data[type])
                        data[type] = {}
                    
                    if(settings.split_init_from_changed_data)
                    {
                        let init_data = settings.models[type][id].config.data;
                        
                        if(!init_data[settings.models[type][id].bind_id])
                            init_data[settings.models[type][id].bind_id] = settings.models[type][id].get_bind_id();
                        
                        if(settings.models[type][id].save_all_data())
                            data[type][id] = {init: settings.models[type][id].get_data()};
                        else if(settings.models[type][id].data.removed == 't')
                            data[type][id] = {init: init_data, changed_data: {...(settings.models[type][id].get_changed_data() || {}), id: settings.models[type][id].data.id, removed: 't'}};
                        else if(_.size(settings.models[type][id].changed_data) > 0)
                            data[type][id] = {init: init_data, changed_data: settings.models[type][id].get_changed_data()};
                    }
                    else
                    {
                        if(settings.models[type][id].save_all_data())
                            data[type][id] = settings.models[type][id].get_data();
                        else if(settings.models[type][id].data.removed == 't')
                            data[type][id] = {id: settings.models[type][id].data.id, removed: 't'};
                        else if(_.size(settings.models[type][id].changed_data) > 0)
                            data[type][id] = settings.models[type][id].get_changed_data();
                    }
                    
                    if(settings.data_as_string && !_.is_empty(data[type][id]))
                        data[type][id] = JSON.stringify(data[type][id]);
                }
            
            if(_.size(data[type]) == 0)
                delete data[type]
        }
        
        return data;
    }
    
    is_saving() {
        if(this.saving)
            return true;
        
        for(let type in this.models)
            if(_.size(this.models[type]) > 0 && _.isPlainObject(this.models[type]))
                for(let id in this.models[type])
                {
                    if(this.models[type][id].saving)
                        return true;
                }
        
        return false;
    }
    
    save(settings)
    {
        if(this.saving)
            return Promise.resolve({status: false, response: 104})
        
        settings = _.extend({url: this.config.save_url, method: 'POST', xhrFields: { withCredentials: true }, headers: {'X-React-App': 1}, credentials: 'include', body: null, debug: false, models: this.models, save_settings: this.config.save_settings, success: this.save_callback.bind(this), remove_models_after_save: this.config.remove_models_after_save, send_node_client_socket_id: true}, settings)
        
        this.setSavingState(true);
        
        if(_.is_empty(settings.body))
        {
            settings.body = {models: this.get_changed_data(settings)};

            if(_.size(settings.body.models) == 0)
                delete settings.body.models
        }
        
        if(_.size(settings.body) == 0)
        {
            this.setSavingState(false);
            
            return Promise.resolve({status: true, response: 105});
        }

        delete settings.models;
        
        if(settings.save_settings)
            settings.body.settings = settings.save_settings;

        if(settings.send_node_client_socket_id && this.config.node.server)
            settings.body.client_socket_id = this.config.node.server.id;

        if(this.ignore_warnings && !settings.body.ignore_warnings)
            settings.body.ignore_warnings = 't';

        settings.body = _.json_to_form_data(settings.body);
        
        let fetch_response = (response) => {
            if(settings.debug)
                console.log(response);
            
            response = JSON.parse(response);

            if(response.status)
            {
                settings.success(response, settings);
                
                this.setSavingState(false);
                
                return response;
            }
            else
            {
                if(!_.is_empty(response.errors))
                {
                    for(let component_id in response.errors)
                        for(let bind_id in response.errors[component_id])
                        {
                            if(this.models[component_id] && this.models[component_id][bind_id])
                                this.models[component_id][bind_id].errors = response.errors[component_id][bind_id];
                        }
                }
                
                if(!_.is_empty(response.warnings))
                {
                    for(let component_id in response.warnings)
                        for(let bind_id in response.warnings[component_id])
                        {
                            if(this.models[component_id] && this.models[component_id][bind_id])
                                this.models[component_id][bind_id].warnings = response.warnings[component_id][bind_id];
                        }
                }
                
                this.setSavingState(false);
                
                return Promise.resolve(response);
            }
        }

        if(settings.onProgress)
            return _.custom_fetch(settings.url, settings).then(fetch_response);

        return fetch(settings.url, settings).then((response) => response.text()).then(fetch_response).catch(err => {
            this.setSavingState(false);
        });
    }

    async save_batch(settings)
    {
        if(this.saving)
            return Promise.reject({status: false, response: 104})
        
        this.setSavingState(true);
        
        settings = _.extend({url: this.config.save_url, method: 'POST', xhrFields: { withCredentials: true }, credentials: 'include', batch_size: 15, body: null, models: this.models, success: this.save_callback.bind(this), remove_models_after_save: this.config.remove_models_after_save}, settings)
        
        if(_.is_empty(settings.body))
        {
            settings.body = {models: this.get_changed_data(settings)};

            if(_.size(settings.body.models) == 0)
                delete settings.body.models
        }
        
        if(_.size(settings.body) == 0)
        {
            this.setSavingState(false);
            
            return Promise.reject({status: false, response: 105})
        }

        delete settings.models;

        let body_batches    = [{}];
        let batch_nr        = 0;
        let count           = 0;
        
        for(let component_id in settings.body.models)
            for(let id in settings.body.models[component_id])
            {
                if(count >= settings.batch_size)
                {
                    batch_nr++;
                    count = 0;
                }
                
                if(!body_batches[batch_nr])
                    body_batches[batch_nr] = {};

                if(!body_batches[batch_nr][component_id])
                    body_batches[batch_nr][component_id] = {};
                
                body_batches[batch_nr][component_id][id] = settings.body.models[component_id][id];
                
                count++;
            }
        
        let response = {status: true, models: {}};

        for(let i in body_batches)
        {
            let data    = _.cloneDeep(settings);
            data.body   = _.json_to_form_data({models: body_batches[i]});
            
            if(this.config.save_settings)
                settings.body.settings = this.config.save_settings;

            await fetch(settings.url, data).then((response) => response.json()).then(responseJson => {
                if(responseJson.status)
                {
                    response.models = _.merge(response.models, responseJson.models);
                }
                else
                    response.status = false;
            });
        }

        settings.success(response, settings);

        this.setSavingState(false);

        return Promise.resolve(response);
    }
    
    save_callback(response, settings)
    {
        if(!response.status)
            return

        for(let type in response.models)
        {
            if(!this.models[type])
                continue;

            for(let bind_id in response.models[type])
            {
                if(this.models[type][bind_id])
                {
                    this.models[type][bind_id].commit_changes({data: response.models[type][bind_id], apply_data_to_state: false, delete_on_removed: true})
                    
                    if(settings.remove_models_after_save)
                    {
                        // Hij kan vanuit de commit_changes al verwijderd worden.
                        if(this.models[type] && this.models[type][bind_id])
                            delete this.models[type][bind_id];
                    }
                    // Hij kan vanuit de commit_changes al verwijderd worden.
                    else if(this.models[type] && this.models[type][bind_id] && this.models[type][bind_id].get_bind_id() != bind_id)
                    {
                        // Nieuwe ID aanmaken
                        this.models[type][this.models[type][bind_id].get_bind_id()] = this.models[type][bind_id];
                        
                        // Oude ID verwijderen
                        delete this.models[type][bind_id];
                    }
                }
            }
        }
        
        if(settings.before_apply_models_to_state_callback)
            settings.before_apply_models_to_state_callback(response, settings);

        this.apply_models_to_state(response.models, {...(response.extraData || {}), ...(!_.is_empty(response.fielddefines) ? {fielddefines: response.fielddefines} : {})}, settings);
    }
    
    release() {
        this.release_node_server_updates();
    }
    
    release_node_server_updates() {
        if(this.config.node.server && this.config.node.components.length > 0)
        {
            this.config.node.server.emit('server stop listening to updates from components', {id: this.id});
            this.config.node.server.off('server receive updates from components ' + this.id);
            this.config.node.server.off('server client initialized', this.bind_node_server_updates.bind(this));
        }
    }
    
    clear(settings) {
        settings = {...{models: [], reset_data_to_state: false, remove_new_item: false}, ...settings};

        for(let component_id in this.models)
            if(_.size(settings.models) == 0 || _.includes(settings.models, _.format_input(component_id)))
            {
                if(settings.reset_data_to_state || settings.remove_new_item)
                    for(let i in this.models[component_id])
                    {
                        if(settings.remove_new_item && !this.models[component_id][i].has_data())
                            this.models[component_id][i].remove({force: true, apply_data_to_state: settings.reset_data_to_state});
                        else if(settings.reset_data_to_state)
                            this.models[component_id][i].reset_data_to_state();
                    }
                
                delete this.models[component_id];
            }
    }
}